import capitalize from 'lodash/capitalize';
export default (string) =>
  (typeof string === 'string' &&
    string
      .split(/[\s-]+/g)
      .map((x) => capitalize(x))
      .join('')) ||
  '';
